export function getCoordinates(point: string): number[] {
	return [
		point.replace("(", "").replace(")", "").split(",")[1] as any,
		point.replace("(", "").replace(")", "").split(",")[0] as any,
	];
}
